import { BracketsItem, SectionItemI } from "../../../shared";
import { StoreWallInterface } from "../../types/store";

/**
 * Обновление кронштейнов в полках
 * @param itemId - id элемента, для которого обновляются кронштейны (может и не быть, после удаления элемента)
 * @param sectionID - id секции, в которой необходимо обновить кронштейны
 * @param currentShelving - текущие секции
 * @param onDragStartPositionY - если item отсутствует (после удаления), на этой высоте произойдет обновление кронштейнов
 */
export const updateBrackets = (
    itemId: string,
    sectionID: string,
    currentShelving: StoreWallInterface,
    onDragStartPositionY?: number
) => {
    const newSections = structuredClone(currentShelving.sections);

    let currentSectionIndex = newSections.findIndex((section) => section.id === sectionID);
    //Обработка sectionID = '', TODO: по факту нужно вычисления sectionID корректного при перемещении полки
    if (currentSectionIndex < 0) {
        for (let i = 0; i < newSections.length; i++) {
            if (newSections[i].items.findIndex((item) => item.id === itemId) >= 0) {
                currentSectionIndex = i;
                break;
            }
        }
    }
    const currentSection = newSections[currentSectionIndex];
    let itemIndex = currentSection.items.findIndex((item) => item.id === itemId);

    //Используется либо для удаленного элемента / либо при удалении секции чтобы обновить соседние элементы
    if (itemIndex === -1) {
        itemIndex = currentSection.items.findIndex((item) => item.position[1] === onDragStartPositionY);
    }
    const item = (currentSection.items[itemIndex] as SectionItemI) || {};
    const shelfY = onDragStartPositionY || item?.position?.[1];
    if (!shelfY) {
        return newSections;
    }
    const prevSection = newSections[currentSectionIndex - 1];

    const brackets: BracketsItem = item.brackets
        ? {
              left: {
                  ...item.brackets.left,
              },
              right: {
                  ...item.brackets.right,
              },
              isExist: item.brackets.isExist,
          }
        : ({
              left: {},
              right: {},
              isExist: false,
          } as BracketsItem);

    let isChangeVisibleLeftBracket = true;
    prevSection?.items.forEach((shelf, index) => {
        const isEqualBrackets =
            shelf?.brackets?.right &&
            item?.brackets?.left &&
            shelf.brackets.right?.elements?.[0]?.type?.toString() ===
                item.brackets.left.elements?.[0]?.type?.toString();
        //Обработка наличия правых кронштейнов предыдущей секции, если поменяли позицию в текущей секции
        if (
            !shelf.brackets.right.isVisible &&
            !currentSection.items.some((curItem) => curItem.position[1] === shelf.position[1])
        ) {
            prevSection.items[index] = {
                ...shelf,
                brackets: { ...shelf.brackets, right: { ...shelf.brackets.right, isVisible: true } },
            };
        }
        if (Math.abs(shelf.position[1] - shelfY) < 0.01 && isEqualBrackets) {
            isChangeVisibleLeftBracket = false;
            if (item.depth > shelf.depth) {
                prevSection.items = prevSection.items.map((prevShelf) => {
                    if (prevShelf.id === shelf.id) {
                        return {
                            ...prevShelf,
                            brackets: {
                                ...prevShelf.brackets,
                                right: { ...prevShelf.brackets.right, isVisible: false },
                            },
                        };
                    }
                    return prevShelf;
                });
                brackets.left.isVisible = true;
            } else {
                brackets.left.isVisible = shelf.isSpirit
                    ? shelf.brackets.right.isVisible
                    : !shelf.brackets.right.isVisible;
            }
        }
    });

    if (isChangeVisibleLeftBracket && !brackets.left.isVisible) {
        brackets.left.isVisible = true;
    }

    const nextSection = newSections[currentSectionIndex + 1];
    let isChangeVisibleRightBracket = true;

    nextSection?.items.forEach((shelf, index) => {
        const isEqualBrackets =
            shelf?.brackets?.left &&
            item?.brackets?.right &&
            shelf.brackets.left?.elements?.[0]?.type?.toString() ===
                item.brackets.right.elements?.[0]?.type?.toString();
        //Обработка наличия левых кронштейнов следующей секции, если поменяли позицию в текущей секции
        if (
            !shelf.brackets.left.isVisible &&
            !currentSection.items.some((curItem) => curItem.position[1] === shelf.position[1])
        ) {
            nextSection.items[index] = {
                ...shelf,
                brackets: { ...shelf.brackets, left: { ...shelf.brackets.left, isVisible: true } },
            };
        }
        if (Math.abs(shelf.position[1] - shelfY) < 0.01 && isEqualBrackets) {
            isChangeVisibleRightBracket = false;
            if (item.depth > shelf.depth) {
                nextSection.items = nextSection.items.map((prevShelf) => {
                    if (prevShelf.id === shelf.id) {
                        return {
                            ...prevShelf,
                            brackets: {
                                ...prevShelf.brackets,
                                left: { ...prevShelf.brackets.left, isVisible: false },
                            },
                        };
                    }
                    return prevShelf;
                });
                brackets.right.isVisible = true;
            } else {
                brackets.right.isVisible = shelf.isSpirit
                    ? shelf.brackets.left.isVisible
                    : !shelf.brackets.left.isVisible;
            }
        }
    });

    if (isChangeVisibleRightBracket && !brackets.right.isVisible) {
        brackets.right.isVisible = true;
    }

    newSections[currentSectionIndex].items[itemIndex] = {
        ...item,
        brackets: {
            ...brackets,
        },
    };
    return newSections;
};
